module.exports = __webpack_public_path__ + "static/media/blackPhone.93b4f775.svg";